// @ts-nocheck
/**
 * TODO : Leaflet pour JS
 * Thomas: J'ai installé les packages 'leaflet' '@types/geoson' & 'types/leaflet' sur Niji.
 * L'import "import * as L from 'leaflet'" ne fonctionne pas. La raison est simple. Il n'aime pas l'utilisation de l'import et de l'option outFile dans le gulp-typescript.
 * Ce qu'il faudrait c'est d'utiliser un module externe pour nos compil en min.js (Webpack est remonté plusieurs fois pendant mes recherches). Il faut qu'on en parle avant de faire quoique ce soit.
 */
console.log('TODO: Leaflet on TS');

class MapDescBloc {
	container: Element;
	private map: L.Map;
	lat: Number;
	lng: Number;

	constructor() {
		this.container = document.querySelector('[data-map-descbloc]');
		this.lat = this.container.getAttribute('data-lat');
		this.lng = this.container.getAttribute('data-lng');
	}

	render() {
		this.invokeMap();
		this.buildMarkers();
	}

	invokeMap() {
		// @ts-ignore
		this.map = new L.Map(this.container, {
			// @ts-ignore
			center: new L.LatLng(this.lat, this.lng),
			zoom: 14,
		});
		// @ts-ignore
		L.tileLayer('https://map.telmedia.fr/tiles/{z}/{x}/{y}.png', {
			maxZoom: 17,
			attribution: '© OpenStreetMap',
		}).addTo(this.map);
	}

	buildMarkers() {
		// @ts-ignore
		const divIcon = L.divIcon({
			className: 'custom-marker-icon',
			html:
				'<img src="' +
				window['moman_global']['osm_marker'] +
				'" alt=""/>',
			iconSize: [30, 42],
			iconAnchor: [15, 42],
		});
		// @ts-ignore
		const marker = L.marker([this.lat, this.lng], {
			icon: divIcon,
		});

		marker.addTo(this.map);
	}
}

document.addEventListener('DOMContentLoaded', () => {
	let leafletBlock = new MapDescBloc();
	leafletBlock.render();

});
